import { Delete, get, patch, post } from "./helpers/http-handler";

const api = process.env.REACT_APP_API_URL;

export const formatInr = (value: number) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const getProducts = (query = "") => get(`${api}/products${query}`);
export const getInventory = (query = "") => get(`${api}/products/inventory${query}`);
export const getProduct = (id: string) => get(`${api}/products/${id}`);
export const createProduct = (payload: object) => post(`${api}/products`, payload);
export const updateProduct = (id: string, payload: object) =>
  patch(`${api}/products/${id}`, payload);
export const deleteProduct = (id: string) => Delete(`${api}/products/${id}`);

export const getCart = () => get(`${api}/cart`);
export const mergeCart = () => post(`${api}/cart/merge`, {});
export const addCartItem = (payload: object) => post(`${api}/cart/items`, payload);
export const updateCartItem = (id: string, payload: object) =>
  patch(`${api}/cart/items/${id}`, payload);
export const removeCartItem = (id: string) => Delete(`${api}/cart/items/${id}`);

export const checkoutOrder = (payload: object) => post(`${api}/orders/checkout`, payload);
export const confirmOrder = (payload: object) => post(`${api}/orders/confirm`, payload);
export const getMyOrders = () => get(`${api}/orders`);
export const getOrder = (id: string) => get(`${api}/orders/${id}`);
export const getOrderStatus = (id: string) => get(`${api}/orders/${id}/status`);
export const getAllOrders = () => get(`${api}/orders/all`);
export const updateOrderStatus = (id: string, payload: object) =>
  patch(`${api}/orders/${id}/status`, payload);
export const cancelOrder = (id: string, payload: object) => post(`${api}/orders/${id}/cancel`, payload);
export const requestReturn = (id: string, payload: object) => post(`${api}/orders/${id}/return`, payload);
export const refundOrder = (id: string, payload: object) => post(`${api}/orders/${id}/refund`, payload);
export const updateOrderAddress = (id: string, payload: object) =>
  patch(`${api}/orders/${id}/address`, payload);
export const updateRefundStatus = (id: string, payload: object) =>
  patch(`${api}/orders/${id}/refund-status`, payload);

export const getApiKeys = () => get(`${api}/api-keys`);
export const getApiScopes = () => get(`${api}/api-keys/scopes`);
export const createApiKey = (payload: object) => post(`${api}/api-keys`, payload);
export const deleteApiKey = (id: string) => Delete(`${api}/api-keys/${id}`);
